import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import ForecastSummaryDashboardWidget from 'widgets/dashboard/ForecastSummaryDashboardWidget'
import DashboardSmartviewNavigation from 'widgets/dashboard/smartviews/DashboardSmartviewNavigation'

export default function ForecastSummaryDashboardSmartview () {
  return (
    <Smartview size='xs'>
      <DashboardSmartviewNavigation active='forecast' />
      <ForecastSummaryDashboardWidget />
    </Smartview>
  )
}
